module.exports = __webpack_public_path__ + "static/media/filter.53f8a309.svg";